import PropTypes from 'prop-types';
import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format';
import { isLocalURL } from '$utilities/browser';
import { slugify } from '../../utilities/slugify.js';
import RichTextWithGlossary from '$partials/glossary/rich-text-with-glossary.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleTextBlock = ({
    bodyText = null,
    introduction = null,
    isAccordionOrSection = null,
    link = null,
    linkLabel = null
}) => {
    const href = formatLinkBlockToUrl(link);
    const target = isLocalURL(href) ? '_self' : '_blank';
    const rel = isLocalURL(href) ? null : 'noreferrer noopener';

    return (
        <section className={`layout-container relative mt-60 mb-40${isAccordionOrSection ? ' md:my-60' : ' md:mt-80 md:mb-60'}`}>
            <div className='layout-grid-negative-gutter md:flex'>
                <div className='md:w-1/12 layout-grid-col-padding' />

                <div className='md:w-11/12 sm:flex items-baseline'>
                    {introduction ? (
                        <>
                            <div
                                className='layout-grid-col-padding sm:w-4/12 md:w-3/11 rich-text type-style-3 mb-20'
                                dangerouslySetInnerHTML={{ __html: introduction}}/>

                            <div className='md:w-1/11' />
                        </>
                    ) : (
                        <div className='layout-grid-col-padding sm:w-4/12 md:w-4/11' />
                    )}

                    <div className='layout-grid-col-padding sm:w-8/12 md:w-6/11'>
                        {bodyText && (
                            <RichTextWithGlossary
                                className='rich-text type-style-4'
                                html={bodyText} />
                        )}

                        {link && linkLabel && (
                            <div className='pt-20 md:pt-30'>
                                <a
                                    className={`pill-button gtm-${slugify(linkLabel)}`}
                                    href={href}
                                    rel={rel}
                                    target={target}>
                                    {linkLabel}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    bodyText: PropTypes.string.isRequired,
    introduction: PropTypes.string,
    isAccordionOrSection: PropTypes.bool,
    link: PropTypes.object,
    linkLabel: PropTypes.string
};

ModuleTextBlock.propTypes = propTypes;

export default ModuleTextBlock;
